import { Steps } from "ant-design-vue";
const { Step, ...other } = Steps;
const YwSteps = {
	...other,
	name: "YwSteps",
	Step: {
		...Step,
		name: "YwStep",
	},
};

YwSteps.install = function (Vue) {
	Vue.component(YwSteps.name, Steps);
	Vue.component(YwSteps.Step.name, Step);
};

export default YwSteps;
